import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';
import utility from './utility';

const DEFAULT_SELECT_LABELS = {
  SELECT_COUNTRY_OF_CITIZENSHIP: 'Select country of citizenship',
  SELECT_A_COUNTRY: 'Select a country',
  SELECT_COUNTRY_OF_TAX_RESIDENCE: 'Select Country of Tax Residence',

};

export default {
  name: 'dataHelper',
  mixins: [utility],
  computed: {
    routeId() {
      return this.$store.getters.routeId;
    },
    locale() {
      return this.$store.getters.locale;
    },
    queryParams() {
      return this.$store.getters.queryParams;
    },
    ...mapFields('currentState', {
      cs_destinationState: 'destinationState',
      cs_editMode: 'editMode',
      cs_flow: 'flow',
      cs_navAction: 'navAction',
      cs_stateName: 'stateName',
    }),
    ...mapFields('formData', {
      pu_employerAddress: 'primaryUser.addresses.employer',
      su_employerAddress: 'secondaryUser.addresses.employer',
      pu_legalAddress: 'primaryUser.addresses.legal',
      pu_mailingAddress: 'primaryUser.addresses.mailing',
      pu_emp_line1: 'primaryUser.addresses.employer.line1',
      su_emp_line1: 'secondaryUser.addresses.employer.line1',
      pu_emp_line2: 'primaryUser.addresses.employer.line2',
      su_emp_line2: 'secondaryUser.addresses.employer.line2',
      pu_emp_city: 'primaryUser.addresses.employer.city',
      su_emp_city: 'secondaryUser.addresses.employer.city',
      pu_emp_state: 'primaryUser.addresses.employer.state',
      su_emp_state: 'secondaryUser.addresses.employer.state',
      pu_emp_zip: 'primaryUser.addresses.employer.zip',
      su_emp_zip: 'secondaryUser.addresses.employer.zip',
      pu_leg_line1: 'primaryUser.addresses.legal.line1',
      su_leg_line1: 'secondaryUser.addresses.legal.line1',
      pu_leg_line2: 'primaryUser.addresses.legal.line2',
      su_leg_line2: 'secondaryUser.addresses.legal.line2',
      pu_leg_city: 'primaryUser.addresses.legal.city',
      su_leg_city: 'secondaryUser.addresses.legal.city',
      pu_leg_state: 'primaryUser.addresses.legal.state',
      su_leg_state: 'secondaryUser.addresses.legal.state',
      pu_leg_zip: 'primaryUser.addresses.legal.zip',
      su_leg_zip: 'secondaryUser.addresses.legal.zip',
      pu_mail_line1: 'primaryUser.addresses.mailing.line1',
      pu_mail_line2: 'primaryUser.addresses.mailing.line2',
      pu_mail_city: 'primaryUser.addresses.mailing.city',
      pu_mail_state: 'primaryUser.addresses.mailing.state',
      pu_mail_zip: 'primaryUser.addresses.mailing.zip',
      pu_coAffillCode: 'primaryUser.coAffillCode',
      su_coAffillCode: 'secondaryUser.coAffillCode',
      pu_coAffillId: 'primaryUser.coAffillId',
      pu_coAffillName: 'primaryUser.coAffillName',
      su_coAffillName: 'secondaryUser.coAffillName',
      pu_coDirectorCode: 'primaryUser.coDirectorCode',
      su_coDirectorCode: 'secondaryUser.coDirectorCode',
      pu_coDirectorName: 'primaryUser.coDirectorName',
      su_coDirectorName: 'secondaryUser.coDirectorName',
      pu_coDirectorSymbol: 'primaryUser.coDirectorSymbol',
      su_coDirectorSymbol: 'secondaryUser.coDirectorSymbol',
      pu_cusip: 'primaryUser.cusip',
      pu_dayPhone: 'primaryUser.dayPhone',
      su_dayPhone: 'secondaryUser.dayPhone',
      pu_mobilePhoneCheckIndicator: 'primaryUser.mobilePhoneCheckIndicator',
      su_mobilePhoneCheckIndicator: 'secondaryUser.mobilePhoneCheckIndicator',
      pu_dob: 'primaryUser.dob',
      su_dob: 'secondaryUser.dob',
      pu_email: 'primaryUser.email',
      su_email: 'secondaryUser.email',
      pu_emailPreferencesEnrolled: 'primaryUser.emailPreferencesEnrolled',
      pu_employerAddressSameAsLegal: 'primaryUser.employerAddressSameAsLegal',
      su_employerAddressSameAsLegal: 'secondaryUser.employerAddressSameAsLegal',
      pu_promotionalText: 'primaryUser.promotionalText',
      pu_promotionalCode: 'primaryUser.promotionalCode',
      pu_employersName: 'primaryUser.employersName',
      su_employersName: 'secondaryUser.employersName',
      pu_employmentStatus: 'primaryUser.employmentStatus',
      su_employmentStatus: 'secondaryUser.employmentStatus',
      pu_firstName: 'primaryUser.firstName',
      su_firstName: 'secondaryUser.firstName',
      pu_middleName: 'primaryUser.middleName',
      su_middleName: 'secondaryUser.middleName',
      pu_lastName: 'primaryUser.lastName',
      su_lastName: 'secondaryUser.lastName',
      pu_mailingSameAsLegal: 'primaryUser.mailingSameAsLegal',
      pu_mailingSendDuplicateToAddress: 'primaryUser.mailingSendDuplicateToAddress',
      pu_occupation: 'primaryUser.occupation',
      su_occupation: 'secondaryUser.occupation',
      pu_receiveAccountDocElectronically: 'primaryUser.receiveAccountDocElectronically',
      pu_residenceCountry: 'primaryUser.residenceCountry',
      su_residenceCountry: 'secondaryUser.residenceCountry',
      pu_ssn: 'primaryUser.ssn',
      su_ssn: 'secondaryUser.ssn',
      pu_strategicAdvisers: 'primaryUser.strategicAdvisers',
      pu_taxCountry: 'primaryUser.taxCountry',
      pu_usCitizen: 'primaryUser.usCitizen',
      pu_viewpointsEnrollment: 'primaryUser.viewpointsEnrollment',
      pu_reviewAndConfirmHTML: 'primaryUser.reviewAndConfirmHTML',
      pu_agreeTermsHTML: 'primaryUser.agreeTermsHTML',
      pu_taxWithHolding: 'primaryUser.taxWithHolding',
      su_taxWithHolding: 'secondaryUser.taxWithHolding',
      pu_clientId: 'primaryUser.clientData.CLIENT_ID',
      pu_clientName: 'primaryUser.clientData.CLIENT_NAME',
      pu_sppEnrollWindowInd: 'primaryUser.clientData.SPP_ENROLL_WINDOW_IND',
      pu_sppEnrolledInd: 'primaryUser.clientData.SPP_ENROLLED_IND',
      pu_sppPlanId: 'primaryUser.clientData.SPP_PLAN_ID',
      pu_bufeCodes: 'primaryUser.clientData.BUFE_CODES',
      pu_existingCustomer: 'primaryUser.existingCustomer',
      pu_cashPosition: 'primaryUser.cashPosition',
      pu_flowType: 'primaryUser.flowType',
      pu_formErrors: 'primaryUser.formErrors',
      pu_additionalDetails: 'primaryUser.additionalDetails',
      au_details: 'additionalUsers',
      acc_details: 'accountDetails',
      pu_gNumber: 'primaryUser.gNumber',
    }),
    ...mapFields('referrerContext', {
      rc_exitUrl: 'exitUrl',
      rc_accountNumber: 'acctNum',
      rc_workItem: 'workItem',
      rc_accountStatus: 'acctStatus',
      rc_transactionId: 'transactionId',
      rc_accountType: 'acctType',
      rc_riskData: 'riskData',
      rc_isProd: 'isProd',
    }),
    ...mapFields('userContext', {
      uc_isCustomer: 'isCustomer',
      uc_hasCustomerCredentials: 'hasCustomerCredentials',
      uc_isPrefilled: 'isPrefilled',
      uc_isMemberOrNonRetail: 'isMemberOrNonRetail',
      uc_isRep: 'isRep',
    }),
    ...mapFields('secondaryUserContext', {
      su_isCustomer: 'isCustomer',
    }),
    ...mapState('pageData', {
      pd_countryList: (state) => state.countryList,
      pd_content: (state) => state.content,
      pd_pageData: (state) => state,
      pd_progressBar: (state) => state.progressBar,
      pd_statesList: (state) => state.statesList,
      pd_envConfig: (state) => state.envConfig,
      pd_validationRules: (state) => state.validationRules,
      pd_affiliations: (state) => state.affiliations,
      pd_cashPositions: (state) => state.cashPositions,
      pd_prospectuses: (state) => state.prospectuses,
    }),
  },
  methods: {
    setRenderData(data) {
      this.prepareCountryList(data.pageData.countryList, data.instanceData.routeId);
      this.setRouteId(data.instanceData.routeId);
      this.setLocale(data.instanceData.locale);
      this.setQueryParams(data.instanceData.queryParams);
      this.setInstanceData('currentState', data.instanceData.currentState);
      if (data.instanceData.formData) {
        this.setInstanceData('formData', data.instanceData.formData.primaryUser, 'primaryUser.');
        this.setInstanceData('formData', data.instanceData.formData.secondaryUser, 'secondaryUser.');

        if (data.instanceData.formData.additionalUsers) {
          this.setListInstanceData('formData', data.instanceData.formData.additionalUsers, 'additionalUsers');
        }
        if (data.instanceData.formData.accountDetails) {
          this.setListInstanceData('formData', data.instanceData.formData.accountDetails, 'accountDetails');
        }
        if (data.instanceData.formData.docusignInfo) {
          this.setListInstanceData('formData', data.instanceData.formData.docusignInfo, 'docusignInfo');
        }
        if (Object.hasOwn(data.instanceData.formData, 'removeUserIndex')) {
          this.setListInstanceData('formData', data.instanceData.formData.removeUserIndex, 'removeUserIndex');
        }
        if (data.instanceData.formData.ectaSignInfo) {
          this.setListInstanceData('formData', data.instanceData.formData.ectaSignInfo, 'ectaSignInfo');
        }
      }
      if (data.instanceData.referrerContext) {
        this.setInstanceData('referrerContext', data.instanceData.referrerContext);
      }
      if (data.instanceData.userContext) {
        this.setInstanceData('userContext', data.instanceData.userContext);
      }
      if (data.instanceData.storageInfo) {
        this.setInstanceData('storageInfo', data.instanceData.storageInfo);
      }
      if (data.instanceData.trustPendingRecord) {
        this.setInstanceData('trustPendingRecord', data.instanceData.trustPendingRecord);
      }
      if (data.instanceData.trustSignerStatus) {
        this.setInstanceData('trustSignerStatus', data.instanceData.trustSignerStatus);
      }
      if (data.instanceData.secondaryUserContext) {
        this.setInstanceData('secondaryUserContext', data.instanceData.secondaryUserContext);
      }
      if (data.instanceData.riskLevel) {
        this.setInstanceData('riskLevel', data.instanceData.riskLevel);
      }
      this.setPageData(data.pageData);
    },
    setPageData(pageData) {
      Object.keys(pageData).forEach((key) => {
        this.$store.dispatch(`pageData/set_${key}`, pageData[key]);
      });
    },
    setRouteId(data) {
      this.$store.dispatch('set_routeId', data);
    },
    setLocale(data) {
      this.$store.dispatch('set_locale', data);
    },
    setQueryParams(data) {
      this.$store.dispatch('set_queryParams', data);
    },
    setInstanceData(module, data, path = '') {
      if (!data) {
        return;
      }
      Object.keys(data).forEach((key) => {
        this.$store.commit(`${module}/updateField`, { path: `${path}${key}`, value: data[key] });
      });
    },
    setListInstanceData(module, data, path) {
      this.$store.commit(`${module}/updateField`, { path: `${path}`, value: data });
    },
    getInstanceData() {
      const instanceData = {};
      instanceData.routeId = this.$store.getters.routeId;
      instanceData.locale = this.$store.getters.locale;
      instanceData.queryParams = this.$store.getters.queryParams;
      instanceData.currentState = this.$store.getters['currentState/currentState'];
      instanceData.formData = this.$store.getters['formData/formData'];
      instanceData.referrerContext = this.$store.getters['referrerContext/referrerContext'];
      instanceData.userContext = this.$store.getters['userContext/userContext'];
      instanceData.secondaryUserContext = this.$store.getters['secondaryUserContext/secondaryUserContext'];
      instanceData.storageInfo = this.$store.getters['storageInfo/storageInfo'];
      instanceData.trustPendingRecord = this.$store.getters['trustPendingRecord/trustPendingRecord'];
      instanceData.trustSignerStatus = this.$store.getters['trustSignerStatus/trustSignerStatus'];
      return instanceData;
    },
    resetFormData() {
      this.$store.commit('formData/resetData');
    },
    commitPrimaryUserData(data, path) {
      const dataToPass = {};
      dataToPass[path] = data;
      this.setInstanceData('formData', dataToPass, 'primaryUser.');
    },
    commitSecondaryUserData(data, path) {
      const dataToPass = {};
      dataToPass[path] = data;
      this.setInstanceData('formData', dataToPass, 'secondaryUser.');
    },
    commitAccountData(data, path) {
      const dataToPass = {};
      dataToPass[path] = data;
      this.setInstanceData('formData', dataToPass, 'accountDetails.');
    },
    commitRcBase64ImageData(data, path) {
      const dataToPass = {};
      dataToPass[path] = data;
      this.setInstanceData('formData', dataToPass, 'rcBase64ImageData.');
    },
    commitAdditionalUserData(data, path, index) {
      const existingUsers = this.getInstanceData().formData.additionalUsers;
      const existingUser = existingUsers[index] ? { ...existingUsers[index] } : null;

      let dataToPass;

      if (existingUser) {
        existingUser[path] = data;
        dataToPass = [...existingUsers];
        dataToPass[index] = existingUser;
      } else {
        const newUser = {};
        newUser[path] = data;
        dataToPass = [...existingUsers, newUser];
      }

      this.setListInstanceData('formData', dataToPass, 'additionalUsers');
    },
    prepareCountryList(countryList, routeId) {
      if (!countryList || !routeId) {
        return;
      }

      if (this.isIStock(routeId)) {
        this.removeUnitedStates(countryList.validCitizenship);
        this.addCountrySelectOption(countryList.validCitizenship,
          DEFAULT_SELECT_LABELS.SELECT_COUNTRY_OF_CITIZENSHIP);

        this.addCountrySelectOption(countryList.validTaxResidency,
          DEFAULT_SELECT_LABELS.SELECT_COUNTRY_OF_TAX_RESIDENCE);
      } else {
        this.addCountrySelectOption(countryList.validCitizenship,
          DEFAULT_SELECT_LABELS.SELECT_A_COUNTRY);
      }
    },
    addCountrySelectOption(validCountryList, optionText) {
      if (validCountryList) {
        validCountryList.unshift({ option: optionText, value: '' });
      }
    },
    removeUnitedStates(countryList) {
      if (countryList) {
        const index = countryList.findIndex((country) => country.option.match(/united states/i));
        countryList.splice(index, 1);
      }
    },
  },
};
